/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import config from "../config/distSelect.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_BANDS } from "../graphql";
import { VApplication } from "../../../application";

import { AppNavigatorService } from "../../appNavigatorService";
import toast from "react-hot-toast";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IDistSelectMethods extends IPluginMethodMap {
  getDistSelect(args: any): Promise<any>;
}

export class DistSelectService implements IAgentPlugin {
  readonly methods: IDistSelectMethods;

  constructor() {
    this.methods = {
      getDistSelect: this.getDistSelect.bind(this),
    };
  }

  async getDistSelect(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_BANDS,
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`bands data`, res.data);
          return {
            ...this.formatBands(res?.data?.getBands?.content),
          };
        }
      }
    } catch (err: any) {
      toast.error(err?.message);
      throw err;
    }
    // return {...(config || {})}
  }

  private formatBands = (bands: any) => {
    let _bands: any[] = [];
    bands &&
      Array.isArray(bands) &&
      bands.length > 0 &&
      bands.forEach((band: any) => {
        _bands.push({
          id: band?.id,
          label: band?.name,
          logo: band?.logo,
          distCenters: this.formatDistCenters(band?.distCents),
        });
      });

    let _tweetyFields: any = config?.tweetyFields;
    _tweetyFields = _tweetyFields?.map((field: any) => {
      if (field?.key === "band") {
        return {
          ...field,
          compProps: {
            ...field?.compProps,
            options: _bands,
          },
        };
      } else {
        return {
          ...field,
        };
      }
    });

    return { tweetyFields: _tweetyFields, bands: _bands };
  };

  private formatDistCenters = (distCenters: any) => {
    let _distCenters: any[] = [];
    distCenters &&
      Array.isArray(distCenters) &&
      distCenters.length > 0 &&
      distCenters.forEach((distCenter: any) => {
        _distCenters.push({
          id: distCenter?.id,
          label: distCenter?.name,
          distCenterId: distCenter?.distCenterId,
          counters: this.formatCounters(distCenter?.counters),
        });
      });
    return _distCenters;
  };

  private formatCounters = (counters: any) => {
    let _counters: any[] = [];
    counters &&
      Array.isArray(counters) &&
      counters.length > 0 &&
      counters.forEach((counter: any) => {
        if (counter?.counterType === "distribution")
          _counters.push({
            id: counter?.id,
            label: counter?.name,
            counterType: counter?.counterType,
            counterNo: counter?.counterNo,
          });
      });
    return _counters;
  };
}
